import instance from 'api';
import { IDynamicTableParams } from 'components/DynamicTable';
import { IAvailableColumnModel, IAvailableGroupColumnModel } from 'interfaces';
import { IApplicationQuestionable, IPosition } from './interfaces';

export const getApplicationQuestionableList = (data: IDynamicTableParams) => {
  return instance()
    .post<IApplicationQuestionable[]>('/applicationQuestionable/list', data)
    .then((response) => response.data);
};

export const getApplicationQuestionableAvailableColumns = () => {
  return instance()
    .post<IAvailableColumnModel[]>('/applicationQuestionable/availableColumns')
    .then((response) => response.data);
};

export const getApplicationQuestionableAvailableGroupColumns = () => {
  return instance()
    .post<IAvailableGroupColumnModel[]>('/applicationQuestionable/availableGroupColumns')
    .then((response) => response.data);
};

export const getApplicationQuestionableListAll = () => {
  return instance()
    .post<IApplicationQuestionable[]>('/applicationQuestionable/listAll')
    .then((response) => response.data);
};

export const getApplicationQuestionableListAllNotDeleted = () => {
  return instance()
    .get<IApplicationQuestionable[]>('/applicationQuestionable/listAllNotDeleted')
    .then((response) => response.data);
};

export const loadApplicationQuestionable = (applicationQuestionableId: number) => {
  return instance()
    .get<IApplicationQuestionable>('/applicationQuestionable/load/' + applicationQuestionableId)
    .then((response) => response.data);
};

export const createApplicationQuestionable = (applicationQuestionable: IApplicationQuestionable) => {
  return instance()
    .post<IApplicationQuestionable>('/applicationQuestionable/save', applicationQuestionable)
    .then((response) => response.data);
};

export const updateApplicationQuestionable = (applicationQuestionable: IApplicationQuestionable) => {
  return instance()
    .post<IApplicationQuestionable>(
      `/applicationQuestionable/${applicationQuestionable.applicationQuestionableId}/update`,
      applicationQuestionable,
    )
    .then((response) => response.data);
};

export const deleteApplicationQuestionable = (id: number) => {
  return instance()
    .post('/applicationQuestionable/archive', { id })
    .then((response) => response.data);
};

export const recoverApplicationQuestionable = (id: number) => {
  return instance()
    .post('/applicationQuestionable/recover', { id })
    .then((response) => response.data);
};

export const getPositions = () => {
  return instance()
    .post<IPosition[]>('/dictionary/positions', {})
    .then((response) => response.data);
};
